import { useState } from "react";

import { Button } from "../components/ui/button";
import { Input } from "../components/ui/misc";
import { api } from "../lib/api";

/** 登录页：邮箱 + 密码。会话由服务端种 HttpOnly Cookie，前端不存 token。 */
export function Login({ onSuccess, notice }: { onSuccess: () => void; notice?: string | null }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.login(email.trim(), password);
      setError(null);
      onSuccess();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "登录失败");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-[var(--color-muted)]">
      <div className="w-80 rounded-xl border border-[var(--color-border)] bg-white p-6 shadow-sm">
        <img src="/izza-logo.svg" alt="IZZA" className="mb-4 h-8 w-auto" />
        {notice ? (
          <p className="mb-3 rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-800">{notice}</p>
        ) : null}
        <p className="mb-5 text-xs text-[var(--color-muted-foreground)]">
          用公司邮箱登录（账号由管理员在「组织管理」里创建）
        </p>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1 text-xs text-[var(--color-muted-foreground)]">
            <span>邮箱</span>
            <Input
              aria-label="邮箱"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="flex flex-col gap-1 text-xs text-[var(--color-muted-foreground)]">
            <span>密码</span>
            <Input
              aria-label="密码"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter" && email && password) void submit();
              }}
            />
          </div>
          {error ? <p className="text-xs text-[var(--color-destructive)]">{error}</p> : null}
          <Button disabled={busy || !email || !password} onClick={() => void submit()}>
            {busy ? "登录中…" : "登录"}
          </Button>
        </div>
        <p className="mt-4 text-[11px] text-[var(--color-muted-foreground)]">
          密码需要重置时，直接找管理员在「组织管理」里点「设置密码」。
        </p>
      </div>
    </div>
  );
}
